import { MessageDialogComponent } from './dialogs/message-dialog/message-dialog.component';
import { VehicleEditComponent } from './vehicle-card/vehicle-edit/vehicle-edit.component';
import { NotificationsModule } from '../notifications/notifications.module';
import { MapLocationCardComponent } from './map-location-card/map-location-card.component';
import { NumberInputMaskPipe } from './pipes/number-input-mask.pipe';
import { VehicleCardNoteComponent } from './vehicle-card/vehicle-card-note/vehicle-card-note.component';
import { ChartsModule } from './charts/charts.module';
import { ErrorPagesModule } from './error-pages/error-pages.module';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { SharedUiModule } from './shared-ui.module';

import { PipesModule } from './pipes/pipes.module';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { LeftSidenavMenuComponent } from './left-sidenav-menu/left-sidenav-menu.component';
import { LeftSidenavControlsComponent } from './left-sidenav-controls/left-sidenav-controls.component';
import { CardComponent } from './card/card.component';
import { EmailConfirmDialogComponent } from './dialogs/email-confirm-dialog/email-confirm-dialog.component';
import { CalendarServiceService } from '../admin-panel/settings/time-restrictions/calendar-service.service';
import { MatDialogModule, MatSelectModule } from '@angular/material';
import { InfoModule } from './info/info.module';
import { HolidaysService } from './services/holidays.service';
import { ClientLogoComponent } from './client-logo/client-logo.component';
import { VehicleCardComponent } from './vehicle-card/vehicle-card.component';
import { StatusIconPipe } from './vehicle-card/pipe/icon-status.pipe';

@NgModule({
  imports: [
    RouterModule,
    CommonModule,
    SharedUiModule,
    PipesModule,
    MatSelectModule,
    ErrorPagesModule,
    TranslateModule.forChild(),
    ChartsModule,
    ReactiveFormsModule,
    InfoModule,
    MatDialogModule,
    NotificationsModule,
  ],
  declarations: [
    LeftSidenavMenuComponent,
    LeftSidenavControlsComponent,
    VehicleCardNoteComponent,
    CardComponent,
    EmailConfirmDialogComponent,
    MapLocationCardComponent,
    VehicleEditComponent,
    MessageDialogComponent,
    ClientLogoComponent,
    VehicleCardComponent,
    StatusIconPipe,
  ],
  exports: [
    SharedUiModule,
    PipesModule,
    ErrorPagesModule,
    TranslateModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    LeftSidenavMenuComponent,
    LeftSidenavControlsComponent,
    VehicleCardComponent,
    VehicleCardNoteComponent,
    ChartsModule,
    CardComponent,
    EmailConfirmDialogComponent,
    InfoModule,
    MapLocationCardComponent,
    VehicleEditComponent,
    MessageDialogComponent,
    ClientLogoComponent,
    StatusIconPipe,
  ],
  providers: [
    CalendarServiceService,
    DatePipe,
    HolidaysService,
    NumberInputMaskPipe,
  ],
})
export class SharedModule {}
